import dayjs from 'dayjs';

/**
 * Subtracts a specified number of days from the given date.
 * @param {*} date
 * @param {*} days
 * @returns
 */
export const subtractDays = (date, days) => {
  return date.setTime(date.getTime() - days * 24 * 60 * 60 * 1000);
};

/**
 * Get the dayjs of the given date time.
 * @param {*} date
 * @returns
 */
export const getDayjsFromRawDateTime = (date) => {
  const parseDate =
    date.substr(0, 4) +
    '-' +
    date.substr(4, 2) +
    '-' +
    date.substr(6, 2) +
    'T' +
    date.substr(8, 2) +
    ':' +
    date.substr(10, 2) +
    ':' +
    date.substr(12, 2);
  return dayjs(parseDate);
};

/**
 * Generate numbers between start and end.
 * @param {Number} start
 * @param {Number} end
 * @returns
 */
export const generateNumbers = (start, end) => {
  const numbers = [];
  for (let i = start; i <= end; i++) {
    numbers.push(i);
  }
  return numbers;
};

/**
 * Get the dayjs of the given date.
 * @param {*} date
 * @returns
 */
export const getDayjsFromRawDate = (date) => {
  const parseDate =
    date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2);
  return dayjs(parseDate);
};

/**
 * Generate year list from the given min year to the given max year.
 * @param {Number} minInput
 * @param {Number} maxInput
 * @returns Array<Number>
 */
export const generateArrayOfYears = (minInput, maxInput) => {
  let max = new Date().getFullYear();
  if (maxInput) {
    max = maxInput;
  }

  let min = max - 9;
  if (minInput) {
    min = minInput;
  }

  return generateNumbers(min, max);
};

/**
 *
 * @param {Number} year
 * @param {Number} month
 * @returns
 */
export const generateDays = (year, month) => {
  const maxDay = new Date(year, month, 0).getDate();
  return generateNumbers(1, maxDay);
};

/**
 * Get age from birth date.
 * https://zenn.dev/awsmgs/articles/96893507976a1f
 * @param {*} birthday
 * @returns
 */
export const getAgeByBirthday = (birthday) => {
  //今日
  var today = new Date();

  //今年の誕生日
  var thisYearsBirthday = new Date(
    today.getFullYear(),
    birthday.month - 1,
    birthday.date
  );

  //年齢
  var age = today.getFullYear() - birthday.year;

  if (today < thisYearsBirthday) {
    //今年まだ誕生日が来ていない
    age--;
  }

  return age;
};

/**
 * //New(希)保険の保険年齢を算出
 * @param {*} birthday
 * @returns
 */
export const getNewsInsuranseAge = (employeeInfo) => {
  if (!employeeInfo) {
    return 30;
  }
  const thisYear = new Date().getFullYear(); //現在年
  const baseDay = new Date(thisYear, 0, 1); //満年齢算出の基準日を現在年1月1日に固定
  const thisYearBirthday = new Date(thisYear, employeeInfo.month-1, employeeInfo.day); //今年の誕生日
  let age = thisYear - employeeInfo.year; //現在年から誕生年を引いて今年に達する年齢を算出

  if(baseDay <= thisYearBirthday){ //誕生日が基準日より後の(まだ誕生日が来ていない)場合-1して現在の満年齢を算出
    age--;
  }
  //誕生日が7/1以前かどうかで年齢を切り上げる
  if(employeeInfo.month < 7){ //誕生日が7月より前の月であれば問答無用で切り上げ
    age++;
  }else if(employeeInfo.month === 7 && employeeInfo.day < 2){ //7月以降でも7月1日以前であれば切り上げ
    age++;
  }

  return age;
}
